import $ from 'jquery'

const closeExpend = () => {
  document.body.classList.remove('mobile-toggle','open-search','open-nav')
  $('.nav-item').removeClass('active')
  $('.expend-menu-wrap').removeClass('show')
  $('.expend-list').removeClass('show')
  $('.expend-search').removeClass('show')
  $('.toggle-shade').off('mouseenter')
}

$('[header-nav]').click(() => {
  if(document.body.classList.contains('open-nav')) {
    closeExpend()
  } else {
    closeExpend()
    document.body.classList.add('mobile-toggle','open-nav')
  }
})

if(window.innerWidth > 1200) {
  $('.nav-item').mouseenter((e) => {
    const { currentTarget } = e
    closeExpend();
    document.body.classList.add('mobile-toggle','open-nav')
    const sub = $(currentTarget).find('a').attr('sub')
    if(sub) {
      $('.expend-menu-wrap').addClass('show')
      $(sub).addClass('show')
    }
    $('.toggle-shade').on('mouseenter',() => {
      closeExpend();
    })
  })
} else {
  $('.nav-item a[sub]').click((e) => {
    const { currentTarget } = e
    closeExpend();
    document.body.classList.add('mobile-toggle','open-nav')
    $(currentTarget).parents('.nav-item').addClass('active')
    const sub = currentTarget.getAttribute('sub')
    if(sub) {
      $('.expend-menu-wrap').addClass('show')
      $(sub).addClass('show')
    }
  })
}

$('.expend-menu-back').click((e) => {
  e.stopPropagation()
  $('.expend-menu-wrap').removeClass('show')
  $('.expend-list').removeClass('show')
})

$('.toggle-shade').click(() => {
  closeExpend()
})

$('[header-search]').click(() => {
  if(document.body.classList.contains('open-search')) {
    closeExpend()
  } else {
    closeExpend()
    document.body.classList.add('mobile-toggle','open-search')
    $('.expend-search').addClass('show')
  }
})

// if(window.innerWidth >= 1200) {
//   $('.nav-item a').mouseenter((e) => {
//     document.body.classList.remove('mobile-toggle','open-search')
//     $('.expend-search').removeClass('show')
//     const { currentTarget } = e
//     const sub = currentTarget.getAttribute('sub')
//     $('.expend-list').removeClass('show')
//     if(sub) {
//       $('#header').addClass('scrolled')
//       $('.expend-menu-wrap').addClass('show')
//       $(sub).addClass('show')
//     } else {
//       if(window.scrollY === 0) {
//         $('#header').removeClass('scrolled')
//       }
//       $('.expend-menu-wrap').removeClass('show')
//     }
//   })
//   $('#header').mouseleave((e) => {
//     if(window.scrollY === 0 && !document.body.classList.contains('open-search')) {
//       $('#header').removeClass('scrolled')
//     }
//     $('.expend-menu-wrap').removeClass('show')
//     $('.expend-list').removeClass('show')
//   })
// } else {
  
// }

Array.from($('.page-home__kv .swiper-slide')).forEach(el => {
  const innerText = $(el).find('.col-10').text()
  if(/^\s*$/.test(innerText)) {
    $(el).find('picture').addClass('not-shade')
  }
})